import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { path } from "./therapyPaths";

function TherapyNav() {
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header className={`demo-nav ${scrolled ? "demo-nav-scrolled" : ""}`}>
            <div className="demo-nav-inner">
                <button
                    className="demo-back"
                    onClick={() => navigate("/portfolio")}
                >
                    ← Portfolio
                </button>

                <Link to={path()} className="demo-logo">
                    Harbor Therapy
                </Link>

                <nav className="demo-links" aria-label="Main">
                    <NavLink to={path("therapists")}>Therapists</NavLink>
                    <NavLink to={path("services")}>Services</NavLink>
                    <NavLink to={path("practice")}>Practice</NavLink>
                    <NavLink to={path("faq")}>FAQ</NavLink>
                    <Link to={path("booking")} className="btn-primary btn-nav">
                        Book
                    </Link>
                </nav>

                <button
                    className="demo-nav-toggle"
                    onClick={() => setMobileOpen(!mobileOpen)}
                    aria-label="Toggle menu"
                    aria-expanded={mobileOpen}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            {mobileOpen && (
                <div className="demo-nav-mobile">
                    <NavLink to={path("therapists")} onClick={() => setMobileOpen(false)}>
                        Therapists
                    </NavLink>
                    <NavLink to={path("services")} onClick={() => setMobileOpen(false)}>
                        Services
                    </NavLink>
                    <NavLink to={path("practice")} onClick={() => setMobileOpen(false)}>
                        Practice
                    </NavLink>
                    <NavLink to={path("faq")} onClick={() => setMobileOpen(false)}>
                        FAQ
                    </NavLink>
                    <NavLink to={path("policies")} onClick={() => setMobileOpen(false)}>
                        Policies
                    </NavLink>
                    <Link
                        to={path("booking")}
                        className="btn-primary"
                        onClick={() => setMobileOpen(false)}
                    >
                        Book
                    </Link>
                </div>
            )}
        </header>
    );
}

export default TherapyNav;